// extracted by mini-css-extract-plugin
export var legendIndicator = "_be-1";
export var legendRight = "_be-0";